<template>
    <div>
        <el-dialog :title="$tx('hygl.components.meetingPlan', '转会议计划')" :visible.sync="hyjhShow" width="1000px" @close="toclose">
            <div>
                <el-form :model="hyjhObj">
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td ref="tdlbl_会议主题" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">会议主题</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="flSubject"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('hygl.components.conferenceThEmeemptyMessage', '请输入会议主题'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '制度标题',
                                                    propName: 'flSubject',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.flSubject',
                                                    option: []
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_会议形式 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'predeterminedType'" class="field">预定类型</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="5">
                                            <form-item
                                                ref="predeterminedType"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: $tx('hygl.components.bookingTypeElementFormatter', '一次性：一次性\n2：部门参会'),
                                                    elementReadonly: 1,
                                                    elementType: 'radio',
                                                    emptyMessage: $tx('hygl.components.bookingTypeEmptyMessage', '请选择会议形式'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '会议形式 ',
                                                    propName: 'predeterminedType',
                                                    propType: 'Short',
                                                    textFormatter: null,
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.predeterminedType',
                                                    option: [
                                                        { value: $tx('hygl.components.ookingTypeOption1', '一次性'), name: $tx('hygl.components.ookingTypeOption1', '一次性') },
                                                        { value: $tx('hygl.components.ookingTypeOption2', '周例会'), name: $tx('hygl.components.ookingTypeOption2', '周例会') },
                                                        { value: $tx('hygl.components.ookingTypeOption3', '月例会'), name: $tx('hygl.components.ookingTypeOption3', '月例会') }
                                                    ],
                                                    optionGenerateType: 0,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="hyjhObj.predeterminedType == '一次性'" :key="2001">
                                        <td ref="tdlbl_会议日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetingDate'" class="field">会议日期</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div>
                                                <el-date-picker v-model="hyjhObj.meetingDate" style="border: 0px; line-height: 33px" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :placeholder="$tx('hygl.components.selectDate', '选择日期')"></el-date-picker>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr v-if="hyjhObj.predeterminedType == '周例会'" :key="2064">
                                        <td ref="tdlbl_会议日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'dateRange'" class="field">应用日期范围</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div>
                                                <el-date-picker v-model="value2" style="line-height: 36px" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" :range-separator="$tx('common.to', '至')" :start-placeholder="$tx('hygl.components.startDate', '开始日期')" :end-placeholder="$tx('hygl.components.endDate', '结束日期')" @change="value2change"></el-date-picker>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="hyjhObj.predeterminedType == '月例会'" :key="2012">
                                        <td ref="tdlbl_会议日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'monthRange'" class="field">应用日期范围</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div>
                                                <el-date-picker v-model="hyjhObj.meetingStartDateStr" type="month" :placeholder="$tx('hygl.components.selectMonth', '选择月')"></el-date-picker>

                                                <span v-text-lbl="'common.to'">至</span>
                                                <el-date-picker v-model="hyjhObj.meetingEndDateStr" type="month" :placeholder="$tx('hygl.components.selectMonth', '选择月')"></el-date-picker>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr v-if="hyjhObj.predeterminedType == '周例会'" :key="2022">
                                        <td ref="tdlbl_会议日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetingTime2'" class="field">会议时间：</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div>
                                                <el-checkbox-group v-model="checkedday" @change="handleCheckedDay">
                                                    <el-checkbox v-for="day in days" :key="day" :label="day">{{ day }}</el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr v-if="hyjhObj.predeterminedType == '月例会'" :key="2222">
                                        <td ref="tdlbl_会议日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetingDate'" class="field">会议日期</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div>
                                                <el-select v-model="hyjhObj.meetingDate" :placeholder="$tx('hygl.components.pleaseSelect', '请选择')">
                                                    <el-option v-for="item in months" :key="item" :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr :key="2003">
                                        <td ref="tdlbl_会议日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetingTimePoint'" class="field">会议时间点</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div>
                                                <el-time-picker
                                                    v-model="value1"
                                                    style="line-height: 36px"
                                                    is-range
                                                    :step-num="5"
                                                    value-format="HH:mm"
                                                    format="HH:mm"
                                                    :range-separator="$tx('common.to', '至')"
                                                    :start-placeholder="$tx('hygl.components.startTime', '开始时间')"
                                                    :end-placeholder="$tx('hygl.components.endTime', '结束时间')"
                                                    :placeholder="$tx('hygl.components.selectTimeRange', '选择时间范围')"
                                                    :picker-options="{
                                                        selectableRange: '00:00:00 - 23:59:59'
                                                    }"
                                                    @change="valuechange(value1)"
                                                ></el-time-picker>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td ref="tdlbl_会议室名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'meetingName'" class="field">会议室名称</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="meetPlace"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 1,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('hygl.components.meetingNameEmptyMessage', '请输入会议类型名称'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 0,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '会议室名称',
                                                    propName: 'meetPlace',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 200,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.meetPlace',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    tbFieldName: 'meetplace',
                                                    dialog: 1,
                                                    dialogType: 'listpage',
                                                    dialogOrgLevel: '',
                                                    dialogListviewurl: 'hygl/type/listdata'
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td ref="tdlbl_会议类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetingTypeName'" class="field">会议类型</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <el-select v-if="canEdit == 1" v-model="hyjhObj.meetingTypeName" placeholder="请选择会议类型" style="width: 100%">
                                                <el-option v-for="item in optionType" :key="item.name" :label="item.name" :value="item.name"></el-option>
                                            </el-select>
                                            <span v-else>
                                                <span>{{ hyjhObj.meetingTypeName }}</span>
                                            </span>
                                            <!-- <form-item
                                                ref="meetingTypeName"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: $tx('hygl.components.meetingTypeElementFormatter', optionTypeFormatter),
                                                    elementReadonly: 1,
                                                    elementType: 'select',
                                                    emptyMessage: '',
                                                    errorMessage: null,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '会议类型',
                                                    propName: 'meetingTypeName',
                                                    propType: 'String',
                                                    textFormatter: null,
                                                    valueMaxLength: 50,
                                                    valueMinLength: null,
                                                    tbFieldName: 'meetingtypename',
                                                    model: 'hyjhObj.meetingTypeName',
                                                    option: optionType,
                                                    formTdAlign: 'text-left',
                                                    optionGenerateType: 1,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            /> -->
                                        </td>
                                        <td ref="tdlbl_会议形式 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetShape'" class="field">会议形式</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="meetShape"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: $tx('hygl.components.meetFormElementFormatter', '1：个人参会\n2：部门参会'),
                                                    elementReadonly: 1,
                                                    elementType: 'radio',
                                                    emptyMessage: $tx('hygl.components.meetFormEmptyMessage', '请选择会议形式'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '会议形式 ',
                                                    propName: 'meetShape',
                                                    propType: 'Short',
                                                    textFormatter: null,
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.meetShape',
                                                    option: [
                                                        { value: '1', name: $tx('hygl.components.personJoin', '个人参会') },
                                                        { value: '2', name: $tx('hygl.components.departJoin', '部门参会') }
                                                    ],
                                                    optionGenerateType: 0,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="hyjhObj.meetShape == 1" :key="1001">
                                        <td ref="tdlbl_个人参会" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'personName'" class="field">个人参会</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="attendName"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('hygl.components.personJoinEmptyMessage', '请输入参会人员姓名'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '个人参会',
                                                    propName: 'attendName',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 1073741823,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.attendName',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    dialog: 1,
                                                    dialogType: 'staff',
                                                    dialogOrgLevel: '',
                                                    dialogSelectedOrderBy: 'orgOrderNo',
                                                    dialogMultiple: true,
                                                    dialogOrgSelf: false,
                                                    dialogOnlyCurSys: true,
                                                    valueIdsField: 'vo.attendId'
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="hyjhObj.meetShape == 2" :key="1002">
                                        <td ref="tdlbl_部门参会" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'attendName'" class="field">部门参会</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="attendName"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '',
                                                    errorMessage: null,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '部门参会',
                                                    propName: 'attendName',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 100,
                                                    valueMinLength: null,
                                                    tbFieldName: 'attendname',
                                                    model: 'hyjhObj.attendName',
                                                    option: [],
                                                    formTdAlign: 'text-left',
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    dialog: 1,
                                                    dialogType: 'suborg',
                                                    dialogOrgLevel: '2',
                                                    dialogMultiple: true
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_参会人数" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'workMum'" class="field">参会人数</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="workMum"
                                                :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '参会人数', propName: 'workMum', propType: 'String', textFormatter: 'textfield', valueMaxLength: 100, valueMinLength: null, tbFieldName: 'workmum', model: 'hyjhObj.workMum', option: [], formTdAlign: 'text-left', autocomplete: 'off', showWordLimit: false }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                        <td ref="tdlbl_会议主持人" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'meetHost'" class="field">会议主持人</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="meetHost"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('hygl.components.meetingHostEmptyMessage', '请输入会议主持人'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 0,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '会议主持人',
                                                    propName: 'meetHost',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 20,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.meetHost',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    dialog: 1,
                                                    dialogType: 'staff',
                                                    dialogOrgLevel: '',
                                                    dialogSelectedOrderBy: 'orgOrderNo',
                                                    dialogMultiple: false,
                                                    dialogOrgSelf: false
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_出席领导" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'attendLeader'" class="field">出席领导</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="attendLeader"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('hygl.components.attendingLeadershipEmptyMessage', '请输入出席领导'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 0,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '出席领导',
                                                    propName: 'attendLeader',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 100,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.attendLeader',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    dialog: 1,
                                                    dialogType: 'staff',
                                                    dialogOrgLevel: '',
                                                    dialogSelectedOrderBy: 'orgOrderNo',
                                                    dialogMultiple: true,
                                                    dialogOrgSelf: false
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_会议内容" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'flContent'" class="field">会议内容</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="flContent"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: 70,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'textarea',
                                                    emptyMessage: $tx('hygl.components.meetingContentEmptyMessage', '请输入会议内容'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 24,
                                                    isRequired: 0,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '内容摘要',
                                                    propName: 'flContent',
                                                    propType: 'String',
                                                    textFormatter: 'textarea',
                                                    valueMaxLength: 1073741823,
                                                    valueMinLength: null,
                                                    model: 'hyjhObj.flContent',
                                                    option: [],
                                                    tbFieldName: 'flcontent',
                                                    autosize: false
                                                }"
                                                :vo="hyjhObj"
                                                :can-edit="canEdit"
                                                :autosize="false"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="$parent && $parent.attachments">
                                        <td ref="tdlbl_附件" class="el-table__cell tdlbl tdw17">
                                            {{ $tx('hygl.components.attach', '附件') }}
                                        </td>
                                        <td class="el-table__cell tdcont tdcont" colspan="5">
                                            <div v-if="$parent && $parent.attachments">
                                                <el-table ref="multipleTable" class="eltable" :show-header="false" :data="attachments" @selection-change="headSelectRow">
                                                    <el-table-column type="selection" style="border: none" width="35px" align="right" :show-overflow-tooltip="true"></el-table-column>
                                                    <el-table-column prop="fileName" style="border: none" :label="$tx('hygl.components.fileName', '文件名')" width="" align="left" :show-overflow-tooltip="true"></el-table-column>
                                                    <el-table-column prop="fileSize" style="border: none" :label="$tx('hygl.components.fileSize', '文件大小')" width="100px" align="right" :show-overflow-tooltip="true"></el-table-column>
                                                </el-table>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" @click="toclose">取消</el-button>
                <el-button v-pageBtn-lbl="'sure'" type="primary" @click="zggzdFn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const dayOptions = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            attachments: [],
            hyjhShow: false,
            selectFileIds: '',
            value1: null, //时间点
            value2: null, //时间段
            // days: dayOptions,
            days: [this.$tx('hygl.components.dayone', '周一'), this.$tx('hygl.components.daytwo', '周二'), this.$tx('hygl.components.daythree', '周三'), this.$tx('hygl.components.dayfour', '周四'), this.$tx('hygl.components.dayfive', '周五'), this.$tx('hygl.components.daysix', '周六'), this.$tx('hygl.components.dayseven', '周日')],
            months: [],
            checkedday: [],
            optionType: [],
            hyjhObj: {},
            nowTime: this.$moment(new Date()).format('YYYY-MM-DD HH:mm')
        }
    },
    computed: {},
    watch: {
        'hyjhObj.meetShape': function (val) {
            this.$set(this.hyjhObj, 'attendName', '')
            this.$set(this.hyjhObj, 'attendId', '')
        },
        'hyjhObj.predeterminedType': function (val) {
            this.$set(this.hyjhObj, 'meetingDate', '')
            this.$set(this.hyjhObj, 'meetingStartDateStr', '')
            this.$set(this.hyjhObj, 'meetingEndDateStr', '')
            this.$set(this.hyjhObj, 'meetingStartTimeStr', '')
            this.$set(this.hyjhObj, 'meetingEndTimeStr', '')
        }
    },
    created() {
        this.$bus.on('btnToHyjhClick', this.btnToHyjhClick)
        // 获取最新会议类型
        this.getClassType()
    },
    beforeDestroy() {
        this.$bus.off('btnToHyjhClick', this.btnToHyjhClick)
    },
    mounted() {
        const days = Array.from({ length: 31 }, (_, i) => i + 1)
        this.months = days.map((day) => this.$tx('hygl.components.day', { day: day }, `${day}号`))
    },
    methods: {

        async getClassType() {
            const param = {
                urlsearch: `status:1`
            }
            const res = await this.$app.listdata('hygl/type/listdata', param)
            console.log(res)
            let arr = []
            res.body.pageInfo.list.forEach((item, index) => {
                arr.push({
                    value: item.id,
                    name: item.typeName
                })
            })
            this.optionType = arr
            // 把 这个数组转化成
            // '新员工入职培训会：新员工入职培训会\n部门讨论会：部门讨论会'
            this.optionTypeFormatter = arr.map((item) => `${item.name}:${item.name}`).join('\n')
            console.log(this.optionTypeFormatter)
        },
        toclose() {
            this.hyjhShow = false
            this.$parent.FromDialogShow = false
            this.$options.components['FromDialog'] = ''
        },
        // 转督办事项
        zggzdFn() {
            const _this = this
            if (!_this.hyjhObj.flSubject) {
                this.$alert(this.$tx('hygl.message.fixTitle', '请填写文件标题！'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }

            if (!_this.hyjhObj.predeterminedType) {
                this.$alert(this.$tx('hygl.message.selectPredeterminedType', '请选择预定类型'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }
            if (!_this.hyjhObj.meetingDate) {
                this.$alert(this.$tx('hygl.message.selectMeetingDate', '请选择会议日期'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }
            if (!_this.hyjhObj.meetingStartTimeStr || !_this.hyjhObj.meetingEndTimeStr) {
                this.$alert(this.$tx('hygl.message.selectMeetingTime', '请选择会议时间点'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }
            if (!_this.hyjhObj.meetingTypeName) {
                this.$alert(this.$tx('hygl.message.selectMeetingTypeName', '请选择会议类型'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }
            if (!_this.hyjhObj.meetShape) {
                this.$alert(this.$tx('hygl.message.selectMeetShape', '请选择会议形式'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }
            if (_this.hyjhObj.meetShape && !_this.hyjhObj.attendName) {
                this.$alert(this.$tx('hygl.message.selectAttendName', '请填入参会内容'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }

            if (this.hyjhObj.passenger.attachments && this.hyjhObj.passenger.attachments.length > 0) {
                this.hyjhObj.passenger.attachments = this.hyjhObj.passenger.attachments.filter((attachment) => {
                    return this.hyjhObj.passenger.selectFileIds.includes(attachment.id)
                })
            }
            if (this.hyjhObj.meetingStartDateStr && this.hyjhObj.predeterminedType === '月例会') {
                const dateObj = new Date(this.hyjhObj.meetingStartDateStr)
                const month = dateObj.getMonth() + 1 // 月份从0开始，需要加1
                this.hyjhObj.meetingStartDateStr = dateObj.getFullYear() + '-' + (month < 10 ? '0' + month : month)
            }
            if (this.hyjhObj.meetingEndDateStr && this.hyjhObj.predeterminedType === '月例会') {
                const dateObj = new Date(this.hyjhObj.meetingEndDateStr)
                const month = dateObj.getMonth() + 1 // 月份从0开始，需要加1
                this.hyjhObj.meetingEndDateStr = dateObj.getFullYear() + '-' + (month < 10 ? '0' + month : month)
            }
            if (this.hyjhObj.meetingDate && this.hyjhObj.predeterminedType === '月例会') {
                this.hyjhObj.meetingDate = this.hyjhObj.meetingDate.replace('号', '')
            }
            this.$http({
                method: 'post',
                url: '/hygl/hyap/activateWfInstance',
                data: this.hyjhObj
            }).then((res) => {
                if (res.code === 'success') {
                    console.log('res', res)
                    this.$message.success(res.message)
                    this.hyjhShow = false
                } else {
                    this.$message.error(res.message)
                    this.hyjhShow = false
                }
            })
        },
        handleCheckedDay() {
            console.log(this.checkedday, 44444)
            this.hyjhObj.meetingDate = this.checkedday.join(',')
        },
        valuechange(val) {
            this.hyjhObj.meetingStartTimeStr = val[0]
            this.hyjhObj.meetingEndTimeStr = val[1]
        },
        value2change(val) {
            if (this.hyjhObj.predeterminedType === '周例会') {
                this.hyjhObj.meetingStartDateStr = val[0]
                this.hyjhObj.meetingEndDateStr = val[1]
            } else {
                this.hyjhObj.meetingStartDateStr = val[0].split('-')[0] + '-' + val[0].split('-')[1]
                this.hyjhObj.meetingEndDateStr = val[1].split('-')[0] + '-' + val[1].split('-')[1]
            }
        },
        onSelectListpageRowCompleted: function (selectedNodes, attr) {
            var _this = this
            console.log('attr', attr)

            if (attr.name === 'meetPlace') {
                _this.hyjhObj.flContent = selectedNodes[0].meetDetails
                _this.hyjhObj.meetingId = selectedNodes[0].id
                _this.hyjhObj.meetPlace = selectedNodes[0].meetName
                _this.hyjhObj.startTime = selectedNodes[0].beginTime.substr(0, 16)
                _this.hyjhObj.endTime = selectedNodes[0].endTime.substr(0, 16)
                _this.hyjhObj.numPeople = selectedNodes[0].numPeople
            }
        },
        onSelectSuborgCompleted(node, attr) {
            let names = []
            let ids = []
            node.forEach((item) => {
                names.push(item.name)
                ids.push(item.id)
            })
            if (attr.name === 'mainDept') {
                this.hyjhObj.mainDept = names.join('、')
                this.hyjhObj.mainDeptId = ids.join(',')
                this.$set(this.hyjhObj, 'mainDept', names.join('、'))
                this.$set(this.hyjhObj, 'mainDeptId', ids.join(','))
            }

            if (attr.name === 'attendName') {
                this.$set(this.hyjhObj, 'attendName', names.join('、'))
                this.$set(this.hyjhObj, 'attendId', ids.join(','))
            }
        },
        onSelectStaffCompleted(node, attr) {
            console.log(node, attr, 'node, attrnode, attr')
            let names = []
            let ids = []
            node.forEach((item) => {
                names.push(item.name)
                ids.push(item.personId)
            })

            if (attr.name === 'attendName') {
                let id = []
                node.forEach((item) => {
                    //names.push(item.name)
                    id.push(item.id)
                })

                this.$set(this.hyjhObj, 'attendName', names.join('、'))
                this.$set(this.hyjhObj, 'attendId', ids.join(','))
                this.$set(this.hyjhObj, 'workMum', ids.length)
            }
            if (attr.name === 'meetHost') {
                this.$set(this.hyjhObj, 'meetHost', names.join('、'))
                this.$set(this.hyjhObj, 'meetHostId', ids.join(','))
            }
            if (attr.name === 'externalPersonName') {
                this.$set(this.hyjhObj, 'externalPersonName', names.join('、'))
                this.$set(this.hyjhObj, 'externalPersonId', ids.join(','))
            }
            if (attr.name === 'summaryName') {
                this.$set(this.hyjhObj, 'summaryName', names.join('、'))
                this.$set(this.hyjhObj, 'summaryId', ids.join(','))
                this.$set(this.hyjhObj, 'summaryPhone', node[0].mobile)
            }
            if (attr.name === 'attendLeader') {
                this.$set(this.hyjhObj, 'attendLeader', names.join('、'))
                this.$set(this.hyjhObj, 'attendLeaderId', ids.join(','))
            }
        },
        toview() {
            console.log(this, 'thisssss')
            window.open('/apigw/' + this.$parent.wfEngineUrl + '/downloadById?attachIds=' + this.bodyfile.id + '&inline=true')
        },
        // 选择附件
        headSelectRow(selection) {
            let selectFiles = ''
            selection.forEach((file) => {
                if (file.id) {
                    if (selectFiles !== '') selectFiles += ','
                    selectFiles += file.id
                }
            })

            this.selectFileIds = selectFiles
            this.hyjhObj.passenger.selectFileIds = this.selectFileIds
            console.log(this.hyjhObj, 'this.selectFileIds')
        },

        // 转会议计划
        btnToHyjhClick() {
            this.hyjhObj = {
                predeterminedType: '一次性',
                meetingDate: '',
                meetingStartDateStr: '',
                meetingEndDateStr: '',
                meetingStartTimeStr: '',
                meetingEndTimeStr: '',
                flContent: '',
                attendLeader: '',
                meetHost: '',
                workMum: 0,
                meetShape: 0,
                meetingTypeName: '',
                meetPlace: '',
                passenger: { attachments: [] },
                flSubject: this.vo.flSubject
            }

            if (this.$parent.attachments) {
                var list = this.$parent.attachments
                list = list.filter((item) => (item.fileType === 'BODY' && item.id === this.$parent.bodyfile.id) || item.fileType !== 'BODY')
                list = JSON.parse(JSON.stringify(list))
                list.forEach((v) => {
                    // if (v.fileType === 'BODY') {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.multipleTable.toggleRowSelection(v)
                        })
                    })
                    //  }
                    if (v.fileName.indexOf('.doc') > -1 && v.fileType === 'BODY') {
                        v.fileName = '文件正文.doc'
                    }
                })
                this.hyjhObj.passenger.attachments = list
                this.attachments = list
            }

            // console.log(this.bodyfile, 'bodyfilebodyfile')
            this.hyjhShow = true
        }
    }
}
</script>

<style scoped lang="scss">
// /deep/ .el-table .cell.el-tooltip{
//     min-width: auto;
// }
/deep/.el-checkbox:last-of-type {
    margin-right: 25px !important;
}
/deep/.el-table td {
    border-bottom: none;
}
.eltable {
    border: 1px solid #ebeef5;
    border-bottom: none;
    /deep/.el-table__body {
        width: 100% !important;
    }
}
/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
    border: none;
    border-bottom: none !important;
}
</style>
